import { render, staticRenderFns } from "./EditTest.vue?vue&type=template&id=688488e3&scoped=true&"
import script from "./EditTest.vue?vue&type=script&lang=js&"
export * from "./EditTest.vue?vue&type=script&lang=js&"
import style0 from "./EditTest.vue?vue&type=style&index=0&id=688488e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688488e3",
  null
  
)

export default component.exports